export default "__VITE_PUBLIC_ASSET__67622112__"